import React, { Component } from 'react'
import { ProjectInfo } from '../../schema/types.d'

interface Props {
  project: ProjectInfo.Fragment
}

class ProjectThumbnail extends Component<Props> {
  render() {
    const project = this.props.project
    return (
      <article
        key={project.id}
        className="w-20 ma3 bg-white br3 pa4-ns mv3 ba b--black-20"
      >
        <div className="dt">
          <div className="dtc v-mid">
            <h1 className="f6 dim pointer">
              <a
                className="f6 hover-grey thumbnail_title"
                href={'/project/' + project.id}
              >
                {project.name}
              </a>
            </h1>
            <p className="f7 black-50 b">#{project.projectNumber}</p>
            <div className="f7 black-50 b">{project.client}</div>
          </div>
        </div>
      </article>
    )
  }
}

export default ProjectThumbnail
